import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { I18nService } from '../services/i18n.service';

// Œil « afficher / masquer » ajouté automatiquement à chaque champ mot de passe de l'application.
// Le champ est placé dans un conteneur `.password-toggle` (le message `.invalid-feedback` qui suit
// reste affiché grâce à la règle `.password-toggle:has(.is-invalid) ~ .invalid-feedback` de styles.scss).
@Directive({
    selector: 'input[type=password]',
    standalone: false
})
export class PasswordToggleDirective implements AfterViewInit, OnDestroy {

  private visible = false;
  private button: HTMLButtonElement | null = null;
  private icon: HTMLElement | null = null;
  private languageSub?: Subscription;

  constructor(
    private element: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
    private i18n: I18nService,
  ) { }

  ngAfterViewInit(): void {
    const input = this.element.nativeElement;
    const parent = this.renderer.parentNode(input);
    if (!parent) {
      return;
    }

    const wrapper = this.renderer.createElement('span');
    this.renderer.addClass(wrapper, 'password-toggle');
    this.renderer.insertBefore(parent, wrapper, input);
    this.renderer.appendChild(wrapper, input);

    this.button = this.renderer.createElement('button');
    this.renderer.setAttribute(this.button, 'type', 'button');
    this.renderer.addClass(this.button, 'password-toggle-btn');
    this.icon = this.renderer.createElement('span');
    this.renderer.addClass(this.icon, 'material-icons');
    this.renderer.setAttribute(this.icon, 'aria-hidden', 'true');
    this.renderer.appendChild(this.button, this.icon);
    this.renderer.appendChild(wrapper, this.button);
    this.renderer.listen(this.button, 'click', () => this.toggle());
    // Le champ garde le focus (pas de fermeture du clavier mobile au clic sur l'œil)
    this.renderer.listen(this.button, 'mousedown', (event: Event) => event.preventDefault());

    this.languageSub = this.i18n.language$.subscribe(() => this.render());
  }

  ngOnDestroy(): void {
    this.languageSub?.unsubscribe();
  }

  private toggle(): void {
    this.visible = !this.visible;
    this.render();
  }

  private render(): void {
    if (!this.button || !this.icon) {
      return;
    }
    const label = this.i18n.t(this.visible ? 'common.hidePassword' : 'common.showPassword');
    this.renderer.setAttribute(this.element.nativeElement, 'type', this.visible ? 'text' : 'password');
    this.renderer.setProperty(this.icon, 'textContent', this.visible ? 'visibility_off' : 'visibility');
    this.renderer.setAttribute(this.button, 'aria-label', label);
    this.renderer.setAttribute(this.button, 'title', label);
    this.renderer.setAttribute(this.button, 'aria-pressed', String(this.visible));
  }
}
